import script from "./AllList.vue?vue&type=script&setup=true&lang=js"
export * from "./AllList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__